import CanvasTestView from './canvasTestView';
import Util from './utils';
import stringsTest from '../../eyeguide-localization/test/string.test';
import service from '../../service/apolloclient.service';
export default class TestDonwloadHelper {
    public async downloadTest(testResult: any, index: number, canvas: any, ser: service) {
        let profileInfo: any = [];
        let baselineTestData: any;
        if (testResult.baseline === 1) {
            baselineTestData = testResult;
            console.log('in baseline');
        } else {
            baselineTestData = await ser.getTestResults(testResult.testid, 1);
            baselineTestData = baselineTestData[0];
        }
        let isOldData = testResult.calibaratedtestcoords === null ? true : false;
        let isOldDataBaseline = baselineTestData.calibaratedtestcoords === null ? true : false;
        canvas.push(document.createElement('canvas'));
        canvas[index].width = 1024;
        canvas[index].height = 768;
        profileInfo.push({
            profileName: testResult.athlete.firstname + ' ' + testResult.athlete.lastname,
            testtimestamp: testResult.testtimestamp,
            isBaseline: testResult.baseline === 1,
            orgName: testResult.athlete.organizationname
        });
        let canvasView: any ;
        canvasView = new CanvasTestView(
            canvas[index], this.getCoords(baselineTestData),
            this.getCoords(testResult) ,
            testResult.baseline === 1, this.checkIfTestsIsImpaired(testResult.range), 
            Util.getLocalizedTestType(testResult.range), 
            Util.formatNumber(testResult.score, 2), 
            isOldData, isOldDataBaseline
        );
        await canvasView.setCanvasView();
        let img: any = new Image();
        img.src = canvas[index].toDataURL();
        img.width = 1024 * 0.5;
        img.height = 768 * 0.5;
        return img;
    }

    /**
     * Formats the test coordinates to set for Test View
     * @param data Data containing test details
     */
    private getCoords(data: any) {
        return  this.formatCorrds( 
            data.calibaratedtestcoords === null ? 
                data.testcoords : data.calibaratedtestcoords);
    }

    private checkIfTestsIsImpaired(range: string) {
        return range !== undefined ? 
        range.indexOf(stringsTest.lsImpairedTxt) !== -1 : false;
     }
 
    private formatCorrds(coords: any) {
         console.log('formatCorrds', coords);
         if (coords !== undefined) {
             let data = coords;
             let formattedData: any = [];
             data.forEach((e: any) => {
                 formattedData.push({x: e.eye_x, y: e.eye_y});
             });
             console.log('formattedData', formattedData);
             return formattedData;
         }
     }
}


// WEBPACK FOOTER //
// ./src/components/common/testDownloadHelper.ts